import { RouteItem } from '@eastcoal/router/types/route'

import { SECRET_AUCTION_PURCHASE_LIST_PAGE_PATH } from './constants/path'

export const secretAuctionPurchaseListRoute: RouteItem = {
  title: '密函',
  path: SECRET_AUCTION_PURCHASE_LIST_PAGE_PATH,
  Component: () => import('./index')
}
